import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import Start from './Start.js';
import Order from './Order.js';
import { fetchPromise } from './apiHelper.js';
import Error from './Error.js';

export default function Returns(props) {
  const [showStartForm, setShowStartForm] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [showHomeDeliveryDesc, setShowHomeDeliveryDesc] = useState(false);
  const [showError, setShowError] = useState(false);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const orderId = urlParams.get('orderId');
    if (!orderId) {
      setShowStartForm(true);
      return;
    }

    const url = '/api/sitecore/returns/GetOrder';
    const options = {
      method: 'POST',
      body: JSON.stringify({
        OrderId: orderId,
      }),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    };
    try {
      fetchPromise(url, options)
        .then((response) => {
          if (response.Success) {
            setShowHomeDeliveryDesc(response.ShipMethodIsHomeDelivery);
            setCurrentOrder(response);
            scrollToTop();
          } else {
            setShowStartForm(true);
          }
        })
        .catch((err) => {
          setShowError(true);
        });
    } catch (err) {
      console.log('error in post request');
      console.log(err);
    }
  }, []);

  return (
    <div className="thule-container returns">
      {showError ? (
        <Error />
      ) : (
        <>
          {currentOrder ? (
            <Order
              {...props}
              currentOrder={currentOrder}
              scrollToTop={scrollToTop}
              showHomeDeliveryDesc={showHomeDeliveryDesc}
            />
          ) : (
            <Start
              {...props}
              showStartForm={showStartForm}
              setShowStartForm={setShowStartForm}
              setCurrentOrder={setCurrentOrder}
              scrollToTop={scrollToTop}
              setShowHomeDeliveryDesc={setShowHomeDeliveryDesc}
            />
          )}
        </>
      )}
    </div>
  );
}

const root = createRoot(document.getElementById('REACT_returns'));
root.render(
  <Sentry.ErrorBoundary>
    <Returns {...window._THULEDATA._Returns} />
  </Sentry.ErrorBoundary>
);
